import Layout from '../components/Layouts/AdminLayout'
import HeaderContainer from '../containers/Header/Header.container'
import SidebarContainer from '../containers/Sidebar/Sidebar.container'
import ListPensionContainer from '../containers/Utm/PensionList.container'
import SupportHelpCard from '../containers/Support/SupportHelpCard'

const Pension = () => {
  return (
    <Layout
      header={<HeaderContainer />}
      sidebar={<SidebarContainer />}
      title="Unidad Tributaria Mensual (UTM)"
    >
      <ListPensionContainer />
      <SupportHelpCard />
    </Layout>
  )
}

export default Pension
